module.exports = __webpack_public_path__ + "img/iphone-loukong.410db795.png";